export default __webpack_public_path__ + "12d37040a0160a948ff141d9053feed4.woff2";